<script setup lang="ts">
  interface Props {
    icon: string;
    subtitle?: string | null;
    title: string;
  }

  defineProps<Props>();
</script>

<template>
  <div class="flex gap-3 items-start">
    <div class="flex justify-center items-center mt-1">
      <i class="fas fa-sparkle text-primary" />
    </div>
    <div class="flex gap-3">
      <p class="space-x-1">
        <span v-html="title" />
        <span v-if="subtitle" v-html="subtitle" />
      </p>
    </div>
  </div>
</template>

<style scoped></style>
